// ─────────────────────────────────────────────
// KLOTHIQ — Supplier Zod Schema
// ─────────────────────────────────────────────

import { z } from 'zod';
import { phoneSchema, emailSchema } from './common.schema';

export const supplierFormSchema = z.object({
  name: z.string().min(1, 'Supplier name is required').max(200, 'Name too long'),
  phone: phoneSchema,
  email: emailSchema,
  address: z.string().max(500).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  contact_person: z.string().max(200).nullable().optional(),
  notes: z.string().max(1000).nullable().optional(),
  is_active: z.boolean().default(true),
});

export type SupplierFormValues = z.infer<typeof supplierFormSchema>;
